<script setup>
import { computed, inject } from "vue"
import { stringNumber } from '../../helpers/functions.js'
import { storage } from '../../storage'
import { aliensTypes } from '../../staticData'

import UpgradeValueItem from './UpgradeValueItem'
const props = defineProps(['alienId'])

const upgrade = inject('upgrade')
const keyName = inject('keyName')

function buyUpgrade() {
    if (!hasEnough.value) return;

    if (!newValue.value) return;

    storage.PINK_COINS -= pinkPrice.value
    storage.BLACK_COINS -= blackPrice.value

    if (props.alienId) storage.UPGRADES_LVLS[keyName][props.alienId] += 1
    else storage.UPGRADES_LVLS[keyName] += 1

}

const currentValue = computed(() => {
    return props.alienId ? upgrade.values[storage.UPGRADES_LVLS[keyName][props.alienId]] : upgrade.values[storage.UPGRADES_LVLS[keyName]]
})
const newValue = computed(() => {
    const res = props.alienId ? upgrade.values[storage.UPGRADES_LVLS[keyName][props.alienId] + 1] : upgrade.values[storage.UPGRADES_LVLS[keyName] + 1]
    // console.log('2', res)
    return res ? stringNumber(res, true) : null
})


const pinkPrice = computed(() => {
    const coins = upgrade.basePrice.pinkC
    if (!props.alienId) {
        const ind = storage.UPGRADES_LVLS[keyName]
        if (ind === 0) return coins
        else if (ind === 1) return coins * 2
        else {
            return Math.ceil((ind + 1) * coins * ind / 2)
        }
    } else {
        const ind = storage.UPGRADES_LVLS[keyName][props.alienId]
        return Math.ceil((ind + 1) * coins * props.alienId / 2)
    }
})

const blackPrice = computed(() => {
    const coins = upgrade.basePrice.blackC
    if (!props.alienId) {
        const ind = storage.UPGRADES_LVLS[keyName]
        if (ind === 0) return coins
        else if (ind === 1) return coins * 2
        else {
            return Math.ceil((ind + 1) * coins * ind / 2)
        }
    } else {
        const ind = storage.UPGRADES_LVLS[keyName][props.alienId]
        return Math.ceil((ind + 1) * coins * props.alienId / 2)
    }
})
const hasEnough = computed(() => {
    return pinkPrice.value <= storage.PINK_COINS && blackPrice.value <= storage.BLACK_COINS;
})

const getAlienUrl = (aId) => {
    const src = aliensTypes.find(({ id }) => id === aId)
    if (src)
        return `/spacebar-clicker/assets/aliens/${src.imgSrc}.png`
}
</script>

<template>
    <div class="row" :class="{ 'alien-row': alienId, 'maxed': alienId && !newValue }">
        <div v-if="alienId !== null">
            <img :src="getAlienUrl(alienId)" alt="" class="alien-sm">
        </div>
        <div class="row upgrade">
            <div class="col">
                <UpgradeValueItem :value="currentValue" :imgType="upgrade.imgType" />
                <!-- <p class="comment">Current</p> -->
            </div>
            <img v-if="newValue" src="/spacebar-clicker/assets/pics/arrow-g.svg" width="40" alt="" style="transform: rotate(180deg);">
            <img v-else src="/spacebar-clicker/assets/pics/action.svg" width="40" alt="">

            <div class="col">
                <UpgradeValueItem :value="newValue" :imgType="upgrade.imgType" />
                <!-- <p class="comment">Next</p> -->
            </div>
        </div>
        <div v-if="newValue" class="price col" :class="{ 'is-enough': hasEnough }" @click="buyUpgrade(upgrade, keyName)">
            <div>
                <img src="/spacebar-clicker/assets/balls/ball_1.png" alt="" style="height: 1.1rem;" >
                <span>
                    {{ stringNumber(pinkPrice) }}
                </span>
                <img src="/spacebar-clicker/assets/balls/ball_9.png" alt="" style="height: 1.1rem;" >
                <span>
                    {{ stringNumber(blackPrice) }}
                </span>
            </div>
            BUY
            <!-- <p class="comment">BUY</p> -->
        </div>
    </div>
</template>

<style scoped>
.alien-sm {
    height: auto;
    width: 45px;
}

.row.alien-row.maxed {
    justify-content: center;
}

.row.alien-row {
    justify-content: space-between;
    margin-top: 5px;
    margin-bottom: 5px;
}

.row {
    overflow: visible;
    justify-content: space-around;
}

.col {
    overflow: visible;
}

.col:hover {
    cursor: default;
}

.upgrade {
    width: fit-content;
}

.upgrade>img {
    margin: 0 15px;
}

.upgrade .col {
    border: 2px solid silver;
    color: white;
    background-color: black;
    border-radius: 50%;
    height: 4.375rem;
    width: 4.375rem;
    /* padding: 0 10px; */
    justify-content: center;
}

.maxed .comment {
    opacity: 0;
}

.col:hover .comment {
    display: block;
}

.perc-sm {
    position: relative;
    bottom: -3px;
}

.price {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    min-width: fit-content;
    margin-right: 10px;
    font-size: 1.2rem;
    background-color: black;
    border-radius: 20px;
    border: 2px solid silver;
    padding: 5px 10px;
    overflow: visible;
    filter: brightness(0.5);
}

.price.is-enough {
    box-shadow: -1px 0px 8px 5px #c0c0c06e;
    filter: brightness(1);

}

.price.is-enough:hover {
    cursor: pointer;
}

.price.is-enough:hover .comment {
    display: block;
}

.price span {
    margin-right: 5px;
    white-space: nowrap;
}


.col .comment {
    bottom: -10px;
    left: 10px;
}

.comment {
    display: none;
    position: absolute;
    background-color: white;
    color: black;
    /* top: 60px; */
    border-radius: 20px;
    bottom: -30px;
    width: 100%;
    height: fit-content;
    left: 0;
    padding: 5px 0;
    text-align: center;
}

@media screen and (max-width: 1200px) {
    .upgrade>img {
        margin: 0 0.5rem;
    }

}
</style>